import React from 'react';

const Clock2SVG = ({ color = 'black', className, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
      onClick={onClick}
    >
      <path
        d='M8.35938 15.0002C12.2254 15.0002 15.3594 11.8663 15.3594 8.00024C15.3594 4.13425 12.2254 1.00024 8.35938 1.00024C4.49338 1.00024 1.35938 4.13425 1.35938 8.00024C1.35938 11.8663 4.49338 15.0002 8.35938 15.0002Z'
        stroke='#737373'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.35938 3.3335V8.00016'
        stroke='#737373'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.6572 11.298L8.35938 8.00024'
        stroke='#737373'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Clock2SVG;
